export default {
	sortBy: 'externalId',
	sortDirection: 'DESC',
};
